import React, { useState, useEffect } from "react";
import switfy from "../../images/swiftui-logo.svg";
import fig from "../../images/figma-logo.svg";
import fram from "../../images/framer-logo.svg";
import web from "../../images/webflow-logo.svg";
import pro from "../../images/protopie-logo.svg";
import sear from "../../images/search.svg";
import star from "../../images/star.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SearchPage from "../../Pages/SearchPages";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function About() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  const Product = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.productList, reqBody).then((response) => {
      setData(response.data.data.product_list);
    });
  };

  useEffect(() => {
    Product();
  }, []);

  return (
    <>
      <div class="wrapper">
        <div class="com">
          <div className="com1">
            <div className="com2 ">
              <p className="com3"> Our Trusted Services </p>
              <h2 className="com4">Our Best Services</h2>
              <p className="com5">Spotlessly Optimized Call Flows</p>
            </div>
            <div className="com6">
              <div className="com7">
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="https://static-00.iconduck.com/assets.00/aws-icon-2048x2048-ptyrjxdo.png"
                      className="h-10"
                    />
                  </div>
                </div>
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJTd9m0Ux-JPLHMZQPteE6-d7tUnZC86YE5PyPeu6V&s"
                      className="h-10"
                    />
                  </div>
                </div>
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="https://static-00.iconduck.com/assets.00/microsoft-azure-icon-512x314-aslik1g6.png"
                      className="h-10"
                    />
                  </div>
                </div>
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbxUVQA2MWL2fX7BvqFj2fulV0Mu8i5VfqwNNhz32e1w&s"
                      className="h-10"
                    />
                  </div>
                </div>
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="	https://cdn-icons-png.flaticon.com/512/4494/4494740.png"
                      className="h-10"
                    />
                  </div>
                </div>
                <div className="com8">
                  <div className="wrapper">
                    <img
                      alt=""
                      src="https://www.ansible.com/hubfs/2016_Images/Assets/Ansible-Mark-Large-RGB-Mango.png"
                      className="h-10"
                    />
                  </div>
                </div>
              </div>
              <SearchPage setClose={setOpen} />
            </div>
          </div>
        </div>
        <div className=" comm4 ">
          <div className="comm5">
            {data?.splice(0, 1).map((item) => {
              return (
                <>
                  <div className="comm6">
                    <p className="comm7">{item.title}</p>
                    <div className="comm8">
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className="comm10">
                            <p className="comm11">1</p>
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>

                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">2</p>{" "}
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">3</p>{" "}
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </>
              );
            })}
            <div className="commm">
              {data?.splice(0, 1).map((item) => {
                return (
                  <>
                    <div className="commm1">
                      <div className=" dd">
                        <div className="dd2">
                          <p className="dd3 pt-5 ">{item.title}</p>
                          <p className=" dd4 pt-4">{item.variant_name}</p>
                          <p className=" dd4 pt-4">{item.slug}</p>
                          <p className="dd3 pt-4">{item.price}</p>
                          <div className="dd5">
                            <div></div>
                          </div>
                        </div>
                        <div className="dd7"></div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div className="comm5">
            {data?.splice(0, 1).map((item) => {
              return (
                <>
                  <div className="comm6">
                    <p className="comm7">{item.title}</p>
                    <div className="comm8">
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className="comm10">
                            <p className="comm11">1</p>
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>

                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">2</p>{" "}
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">3</p>{" "}
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </>
              );
            })}
            <div className="commm">
              {data?.splice(0, 1).map((item) => {
                return (
                  <>
                    <div className="commm1">
                      <div className=" dd">
                        <div className="dd2">
                          <p className="dd3 pt-5 ">{item.title}</p>
                          <p className=" dd4 pt-4">{item.variant_name}</p>
                          <p className=" dd4 pt-4">{item.slug}</p>
                          <p className="dd3 pt-4">{item.price}</p>
                          <div className="dd5">
                            <div></div>
                          </div>
                        </div>
                        <div className="dd7"></div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          {/* <div className="comm5">
            {data?.map((item) => {
              return (
                <>
                  <div className="comm6">
                    <p className="comm7">{item.title}</p>
                    <div className="comm8">
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">1</p>
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>

                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">2</p>
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                      <span className="comm9">
                        <div className="sectionRow">
                          <div className=" comm10">
                            <p className="comm11">3</p>{" "}
                          </div>

                          <div className="comm12">
                            <p className="comm13">{item.variant_name}</p>
                            <p
                              className="comm14"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </>
              );
            })}
            <div className="commm">
              {data?.map((item) => {
                return (
                  <>
                    <div className="commm1">
                      <div className=" dd">
                        <div className="dd2">
                          <p className="dd3 pt-5 ">{item.title}</p>
                          <p className=" dd4 pt-4">{item.variant_name}</p>
                          <p className=" dd4 pt-4">{item.slug}</p>
                          <p className="dd3 pt-4">{item.price}</p>
                          <div className="dd5">
                            <div></div>
                          </div>
                        </div>
                        <div className="dd7"></div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
